module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "blcc-book-pages1"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "blcc-book-pages1"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The aftermath of the Second World War saw the publication of many novels set in prisoner of war camps, ranging from ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Colditz Story ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("and ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wooden Horse")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" to ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Escape")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(". Michael Gilbert’s ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Death in Captivity")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" is unique, however, in offering an “impossible crime” murder mystery set in an Italian P.O.W. camp.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("There is a good deal in the story to delight the fan of classic Golden Age detective fiction. Take, for instance, the central puzzle, which is neatly summarized in Robert Adey’s survey ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Locked Room Murders")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(": it concerns the “death by suffocation of the only man in an escape tunnel that could only be entered with the help of at least three men.” As if that isn’t tantalizing enough, the prison camp setting ensures a “closed circle” of suspects in the finest Agatha Christie tradition. And there is even an amateur detective—“Cuckoo” Goyles, alias Henry Goyles, a bespectacled schoolmaster who was the son of a solicitor. Given that Michael Gilbert was a bespectacled schoolmaster who became a solicitor after the war, there is perhaps an element of self-portrait, or at least witty self-")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("caricature")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(", in the way Goyles is presented.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The murder victim is an unpopular Greek prisoner, a suspected informer called Cyriakos Coutoules. His body is found beneath a fall of sand in Campo 127’s most promising escape tunnel. The challenge for Goyles is to conduct a murder investigation with no help from the official police in a community where the camp’s inmates “really did know everything about everybody else.” Ultimately, he comes up with a solution to the crime neat enough to satisfy lovers of “fair play” detective fiction.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("All this would be enough to guarantee an enjoyable read. But there is more. As he did in other novels, Michael Gilbert combines a teasing mystery with a pacy action thriller. The battle of wits between the prisoners desperate to get away from Campo 127 and their Italian captors is conveyed amusingly yet with an underlying seriousness. Gilbert does not flinch from the brutalities of war, including torture and other vicious punishments, but he does not dwell on them, or describe them in graphic and extensive detail.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Perhaps this habitual restraint—discretion, rather than caution—is the reason why his work has occasionally been damned with faint praise by critics (including his illustrious friends and contemporaries Julian Symons and Harry Keating, both of whom admired his work) who suggested that his gifts as a novelist were such that he should have been more ambitious in exploiting them. Yet as Gilbert said, in a characteristically mild but no doubt deeply felt rejoinder in ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Twentieth Century Crime and Mystery Writers")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(": “I find the whole thing puzzling. What is a writer to do if he is not allowed to entertain?” Taken as a whole, the quality of his fiction does not, in my opinion, suffer in comparison with that of the similarly excellent work of Symons and Keating.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Entertaining the reader always remained Gilbert’s priority as a storyteller, and his tales were told with such elegance and economy that they have stood the test of time far better than the work of most of his contemporaries. A facet of his writing that has, however, often been underestimated is its authenticity. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Death in Captivity")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" is an outstanding example of his flair for making use of his own knowledge in the service of an enjoyable crime story. For Gilbert had himself endured the wretched experience of being a prisoner in an Italian P.O.W. camp.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("At the start of the Second World War, he joined the Royal Horse Artillery, and was mentioned in dispatches in 1943, before being captured in Africa, and transferred to Italy. A bold initial escape attempt—by jumping from a moving train—failed, but accompanied by two friends, he escaped from the Fontanellato camp at the time of the Italian surrender, eventually fictionalizing his adventures in ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Long Journey Home")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" (1943); his companions, the travel writer Eric Newby and Tony Davies, also wrote about their joint exploits, in ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Love and War in the Apennines")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" and ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("When the Moon Rises,")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" respectively.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Together with Davies and another escapee, Toby Graham, Gilbert was later joined by a South African called Hans Becker; they made it to the front line before Becker was shot dead and Davies was wounded. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Death in Captivity")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" is dedicated to Davies and Graham. Many years later, Gilbert learned that four members of a family who had given them shelter during the journey had been shot dead in reprisal by German troops. Local farmers often helped them, and after the war, as a mark of his gratitude for their courage, Gilbert ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("subscribed to a charity, the Monte San Martino Trust, which gives study bursaries to young Italians. Among the many other charities to which he subscribed was the Red Cross, without whose food parcels, he said, he and the other prisoners would have starved.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The novel’s excellence was quickly recognized on both sides of the Atlantic. In the U.S., it was called ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Danger Within")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(", and a film version released in 1959 was given the title ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Danger Within")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" in Britain and ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Breakout ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("in the U.S. The director was Don Chaffey (whose other movies included ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jason and the Argonauts")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(") and the script was co-written by Bryan Forbes. Richard Todd led an excellent cast, which included such stalwarts of British film and television as Richard Attenborough, Bernard Lee, Michael Wilding, Dennis Price, Donald Houston, William Franklyn, and Terence Alexander. Peter Arne, who was himself murdered in 1983, played Benucci. An uncredited part as a love-lorn prisoner of war was played by the young Michael Caine. To this day, the film remains well worth watching.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages4"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("But the novel is even better. It ranks as one of the finest achievements of a crime writer of distinction.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages5"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("Martin Edwards")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages5"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text"
    }
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("www.martinedwardsbooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a565514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Introduction.vue
// module id = 75
// module chunks = 0